import React, { useState } from 'react';
import { Box, Typography, Snackbar, Alert } from '@mui/material';
import { Header } from '../../components';
import { customStyles } from '../../Utils/utils';
import FeatureControlTable from './FeatureControlTable';
import { cardiacTokens as T } from '../../theme/cardiacTheme';

/* ════════════════════════════════════════════════════════════════════════
   Feature control (SUPER_ADMIN only) — what each clinic is entitled to use.

   Kept separate from Manage Clinics on purpose: that screen is where a clinic's
   identity, address and templates are edited, and an entitlement switch buried
   in a long form is both easy to miss and easy to flip by accident. This is a
   one-screen answer to "who has the viewer, who has measurement".
   ════════════════════════════════════════════════════════════════════════ */

const FeatureControl: React.FC = () => {
  const [toast, setToast] = useState<{ msg: string; sev: 'success' | 'error' } | null>(null);

  return (
    <>
      <section
        className="layoutContainer"
        style={customStyles.layoutBackground}
      >
        <div className="layoutGrid">
          <div className="page page--fullBody">
            <Header />
            <div className="page__body">
              <Box sx={{ p: '20px 30px 40px', overflowY: 'auto', flex: 1, minHeight: 0 }}>
                <Box sx={{ mb: '18px' }}>
                  <Typography
                    sx={{ fontSize: 26, fontWeight: 800, color: '#fff', lineHeight: 1.1 }}
                  >
                    Feature control
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: T.ink3, mt: '3px' }}>
                    Which optional products each clinic may use
                  </Typography>
                </Box>

                <FeatureControlTable notify={(msg, sev) => setToast({ msg, sev })} />
              </Box>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={!!toast}
        autoHideDuration={6000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity={toast?.sev || 'success'}
          onClose={() => setToast(null)}
          variant="filled"
        >
          {toast?.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FeatureControl;
